import React from 'react';
import BlockMsg from '../components/BlockMsg';
function TooLargeMessage(_ref) {
  var model = _ref.model;
  var regionTooLargeReason = model.regionTooLargeReason;
  return React.createElement(BlockMsg, {
    severity: "warning",
    action: function action() {
      if (!model.estimatedRegionStats) {
        console.error('No global stats?');
      } else {
        model.updateStatsLimit(model.estimatedRegionStats);
        model.reload();
      }
    },
    buttonText: "Force load",
    message: "".concat(regionTooLargeReason ? regionTooLargeReason + '. ' : '', "\n      Zoom in to see features or force load (may be slow).")
  });
}
export default TooLargeMessage;